import LoginComponent from '../kp-login.component';

export default abstract class AbstractLoginSystem {
    public require = {
        loginController: `^${LoginComponent.componentName}`
    };

    public bindings = {
        authSystemView: '<',
        loginView: '<'
    };
}
